module.exports = __webpack_public_path__ + "static/img/ys6.9d00adc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ys6.jpeg
// module id = Ooze
// module chunks = 73